<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-avatar v-on="on" :class="btnClass" :size="size" :disabled="disabled" @click="actionClick" v-if="size==='x-small'">
                <v-icon color="white" x-small>{{ icon }}</v-icon>
            </v-avatar>
            <v-avatar v-on="on" :class="btnClass" :size="size" :disabled="disabled" @click="actionClick" v-if="size==='small'">
                <v-icon color="white" small>{{ icon }}</v-icon>
            </v-avatar>
            <v-avatar v-on="on" :class="btnClass" :size="size" :disabled="disabled" @click="actionClick" v-if="size==='default'">
                <v-icon color="white" default>{{ icon }}</v-icon>
            </v-avatar>
            <v-avatar v-on="on" :class="btnClass" :size="size" :disabled="disabled" @click="actionClick" v-if="size==='large'">
                <v-icon color="white" large>{{ icon }}</v-icon>
            </v-avatar>
            <v-avatar v-on="on" :class="btnClass" :size="size" :disabled="disabled" @click="actionClick" v-if="size==='x-large'">
                <v-icon color="white" x-large>{{ icon }}</v-icon>
            </v-avatar>
        </template>
        <span v-html="convertTextToHtml(tooltip)"></span>
    </v-tooltip>
</template>

<script>
    export default { 
        props: {
            data: {
                required: true,
            },
            icon: {
                type: String,
                required: false,
                default: ""
            },
            text: {
                type: String,
                required: false,
                default: ""
            },
            tooltip: {
                type: String,
                required: false,
                default: "Click me",
            },    
            size: {
                type: String,
                required: false,
                default: "default",
            },
            color: {
                type: String,
                required: false,
                default: "primary",
            },
            disabled: {
                type: Boolean,
                required: false,
                default: false,                
            }
        },
        data() {
            return {
            }
        },
        computed: {
            btnClass: function () {
                return "action mx-1 " + this.color;
            }
        },
        methods: {
            actionClick() {
                this.$emit("actionClick", this.data);
            },
            convertTextToHtml(text) {
                return text.replace(/\n/gi, '<br>'); // yes indeed, regular expression!!
            },
        },
    }

</script>

<style scoped>
    .action {
        cursor: pointer;
    }
</style>